import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { TableCollectionActionDisabilityPipe } from '../../pipes/table-collection-action-disability.pipe';
import { Nillable } from '@web/utils';
import { ButtonModule } from 'primeng/button';
import { TableCollectionAction } from '../../models/table-collection-action';
import { PrimengButtonDirective } from '../../../button/directives/primeng-button.directive';
import { NegatePipe } from '../../../boolean/pipes/negate.pipe';
import { TrueOrFalsePipe } from '../../../boolean/pipes/true-or-false.pipe';
import { TableRowsSelection } from '../../models/table-rows-selection';

@Component({
  selector: 'app-table-collection-action',
  imports: [
    ButtonModule,
    TooltipModule,
    TableCollectionActionDisabilityPipe,
    NegatePipe,
    TrueOrFalsePipe,
    PrimengButtonDirective,
  ],
  templateUrl: './table-collection-action.component.html',
  styleUrls: ['./table-collection-action.component.scss'],
})
export class TableCollectionActionComponent<Item, Filter, Action> {
  @Input() public action!: TableCollectionAction<Item, Filter, Action>;
  @Input() public selection!: Nillable<TableRowsSelection<Item, Filter>>;

  public handleClick(): void {
    this.executeCommand();
  }

  private executeCommand(): void {
    this.action.command(this.selection!);
  }
}
